import React, { useState } from 'react';
import { bool, func, string, object } from 'prop-types';
import { get } from 'lodash';
import { Modal, FlexContainer, Row, Text, Column, Button, If } from '../../common';
import { withApollo } from 'react-apollo';
import { SEND_NOTIFICATION } from '../../../queries';

const DisconnectPicker = ({ client, onClose, email, showModal }) => {
    const [mutationStatus, setMutationStatus] = useState(false);
    const [mutationInProcess, setMutationInProcess] = useState(false);

    const modalProperties = () => {
        switch (mutationStatus) {
            case 'success':
                return {
                    text: 'Se ha desconectado al Picker.',
                    onConfirm: () => onClose(setMutationStatus(false))
                };
            case 'error':
                return {
                    text: 'Hubo un error al intentar desconectar al Picker.',
                    onConfirm: onClose
                };
            default:
                return {
                    text: '¿Está seguro de realizar esta acción?',
                    onConfirm: () => {
                        setMutationInProcess(true);
                        client.mutate({
                            mutation: SEND_NOTIFICATION,
                            variables: {
                                input: {
                                    email,
                                    notificationType: 15,
                                    title: 'Usuario desconectado',
                                    message: 'Tu usuario fue desconectado de la aplicación Picker Up',
                                    sendPush: true
                                }
                            }
                        }).then(
                            setTimeout(() => {
                                client.reFetchObservableQueries();
                                setMutationInProcess(false);
                                setMutationStatus('success');
                            }, 5000)
                        ).catch((error) => {
                            console.error(error);
                            setMutationInProcess(false);
                            setMutationStatus('error');
                        });
                    }
                };
        };
    };

    return (
        <Modal
            visible={showModal}
            title='Desconectar Picker'
            width={300}
            onClose={onClose}
        >
            <FlexContainer direction='column'>
                <Row justify='center' padding={10}>
                    <Text text={get(modalProperties(), 'text')} />
                </Row>
                <Row>
                    <If
                        condition={!mutationStatus}
                        then={
                            <Column align='end' padding={10}>
                                <Button link text='Cancelar' width={94} onClick={onClose} />
                            </Column>
                        }
                    />
                    <Column padding={10} align={mutationStatus && 'center'}>
                        <Button text='Confirmar' loading={mutationInProcess} width={94} onClick={get(modalProperties(), 'onConfirm')} />
                    </Column>
                </Row>
            </FlexContainer>
        </Modal>
    );
};

DisconnectPicker.propTypes = {
    showModal: bool,
    onClose: func,
    email: string,
    client: object
};

export default withApollo(DisconnectPicker);
